import React from "react"
import { Box, Button, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


const TONES = {
	info: { tint: dsColorNew.noteInfoBg, color: dsColorNew.noteInfo, button: dsColorNew.appBlue, hover: dsColorNew.appBlueHover, icon: 'circle-question' },
	warning: { tint: dsColorNew.noteAmberBg, color: dsColorNew.noteAmber, button: dsColorNew.appBlue, hover: dsColorNew.appBlueHover, icon: 'triangle-exclamation' },
	danger: { tint: dsColorNew.dangerBg, color: dsColorNew.dangerRed, button: dsColorNew.dangerRed, hover: dsColorNew.dangerRed, icon: 'trash-can' },
}

const buttonSx = {
	height: 32,
	px: 1.5,
	minWidth: 0,
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: 13,
	fontWeight: 500,
	boxShadow: 'none',
	'&:hover': { boxShadow: 'none' },
}

// Body of a confirmation notice: what it asks and the two answers. Clicking either answer closes the notice
// (the notifier closes on click), exactly as before.
export default function AppConfirmToast({ msg, title, tone = 'info', icon, onSubmit, submitText = 'OK', onCancel, cancelText = 'Cancel' }) {
	const look = TONES[tone] || TONES.info

	return <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
		<Box sx={{
			width: 30, height: 30, borderRadius: '8px', flexShrink: 0,
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: look.tint, color: look.color,
		}}>
			<IconSeeker icon={icon || look.icon} sx={{ fontSize: 14 }}/>
		</Box>
		<Box sx={{ minWidth: 0 }}>
			{!!title && <Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.35 }}>{title}</Typography>}
			<Typography sx={{ fontSize: 13, fontWeight: 400, color: title ? dsColorNew.textMuted : dsColorNew.textTitle, lineHeight: 1.45, mt: title ? 0.25 : 0.5 }}>{msg}</Typography>
			<Box sx={{ display: 'flex', gap: 1, mt: 1.25 }}>
				<Button variant="contained" onClick={onSubmit} sx={{ ...buttonSx, backgroundColor: look.button, '&:hover': { ...buttonSx['&:hover'], backgroundColor: look.hover } }}>
					{submitText}
				</Button>
				<Button variant="text" onClick={onCancel} sx={{ ...buttonSx, color: dsColorNew.textMuted, backgroundColor: 'transparent', '&:hover': { ...buttonSx['&:hover'], backgroundColor: dsColorNew.pillTrackBg } }}>
					{cancelText}
				</Button>
			</Box>
		</Box>
	</Box>
}
